import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            <div className="lg:w-1/3">
              <Link
                to="/"
                className="font-heading text-xl text-foreground-950 hover:text-primary-500 transition-colors duration-200"
              >
                妈妈的朋友们
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                一个温暖真实的情感故事平台，聚焦妈妈与闺蜜间的深厚情谊、生活哲学与人生智慧。在这里，发现母辈女性友情的动人故事。
              </p>
            </div>

            <div className="flex-1 flex flex-col sm:flex-row gap-6 sm:gap-12">
              <div>
                <h4 className="font-label text-sm font-medium text-foreground-950 mb-3">
                  快速导航
                </h4>
                <div className="flex flex-col space-y-2">
                  <Link
                    to="/"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    首页
                  </Link>
                  <Link
                    to="/category/mama-yu-guimi"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    故事分类
                  </Link>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </div>
              </div>

              <div>
                <h4 className="font-label text-sm font-medium text-foreground-950 mb-3">
                  热门分类
                </h4>
                <div className="flex flex-col space-y-2">
                  <Link
                    to="/category/mama-yu-guimi"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    妈妈与闺蜜
                  </Link>
                  <Link
                    to="/category/shenghuo-zhihui"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    生活智慧
                  </Link>
                  <Link
                    to="/category/qinggan-gongming"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    情感共鸣
                  </Link>
                  <Link
                    to="/category/rensheng-ganwu"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    人生感悟
                  </Link>
                </div>
              </div>

              <div>
                <h4 className="font-label text-sm font-medium text-foreground-950 mb-3">
                  联系方式
                </h4>
                <div className="flex flex-col space-y-2">
                  <a
                    href="mailto:hello@momfriends.cn"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    <i className="ri-mail-line mr-1"></i>
                    hello@momfriends.cn
                  </a>
                  <span className="text-sm text-foreground-600 whitespace-nowrap">
                    <i className="ri-map-pin-line mr-1"></i>
                    北京市朝阳区
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 妈妈的朋友们. 保留所有权利.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                rel="nofollow"
              >
                隐私政策
              </a>
              <a
                href="#"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                rel="nofollow"
              >
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}